exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CoverImage__carouselImageClassName___1nb65 {\n  height: 149px; }\n\n.CoverImage__image____4cqq {\n  height: 149px;\n  border-radius: 6px; }\n", ""]);

// exports
exports.locals = {
	"carouselImageClassName": "CoverImage__carouselImageClassName___1nb65",
	"image": "CoverImage__image____4cqq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/MyAdsPage/MyAds/CoverImage/CoverImage.scss
// module id = 4958
// module chunks = 6